<script setup></script>

<template>
  <header class="relative bg-indigo">
    <div class="container relative">
      <div class="flex h-16 items-center justify-between py-16">
        <div class="flex flex-1 justify-start items-center">
          <div class="flex flex-shrink-0 items-center">
            <a
              href="/"
              class="outline-none focus:ring-2 focus:ring-white rounded-md p-1"
            >
              <slot name="logo" />
            </a>
          </div>
          <slot name="left-nav" />
        </div>
        <div class="flex lg:items-end pr-2 sm:pr-0 max-lg:items-center">
          <slot name="right-nav" />
        </div>
      </div>
    </div>
  </header>
</template>
